import { Capacitor } from "@capacitor/core";
import { Network } from "@capacitor/network";
import { useEffect, useState } from "react";


export default function NetworkDetector() {

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const isNative = Capacitor.isNativePlatform();
    const handleOffline = () => {
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 5000); // disparait après 5s
    };

    const handleOnline = () => {
      setShowBanner(false); // On cache directement
    };

    // Pour désinscrire les écouteurs Capacitor
    let removeCapacitorListener: (() => void) | null = null;

    const init = async () => {
      if (isNative) {
        // Capacitor plugin
        const status = await Network.getStatus();
        if (!status.connected) handleOffline();

        const listener = await Network.addListener('networkStatusChange', (status) => {
          status.connected ? handleOnline() : handleOffline();
        });

        removeCapacitorListener = listener.remove;
      } else {
        // Navigateur (web ou mobile)
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);

        if (!navigator.onLine) handleOffline();
      }
    };

    init();

    return () => {
      if (isNative && removeCapacitorListener) {
        removeCapacitorListener();
      } else {
        window.removeEventListener('offline', handleOffline);
        window.removeEventListener('online', handleOnline);
      }
    };
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 w-full text-white text-center py-2 z-50 shadow-md transition-opacity duration-1000 ${showBanner ? "bg-red-600 opacity-100" : "opacity-0 pointer-events-none"
        }`}
    >
      🚫 Vous êtes hors ligne. Certaines fonctionnalités sont limitées.
    </div>
  );
}